import { PictureOutlined } from "@ant-design/icons";
import Image from "next/image";
import { ComponentProps, useState } from "react";

import styles from "./image-with-stub.module.css";

type Props = ComponentProps<typeof Image>;

export const ImageWithStub = (props: Props) => {
  const [isVisibleStub, setIsVisibleStub] = useState(false);

  return !isVisibleStub && props.src ? (
    <Image {...props} onError={() => setIsVisibleStub(true)}></Image>
  ) : (
    <div
      id={styles.stubWrapper}
      className={props.className}
      style={{ ...props.style, height: props.height, width: props.width }}
    >
      <PictureOutlined
        width={40}
        height={40}
        style={{ color: "white", fontSize: "20px" }}
      />
    </div>
  );
};
